export const engagementSegmentsCanExportAllAttributes = "/engagement/segments/can_export_all_attributes";
